var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _polygon, _path7, _path8, _rect2, _path9, _rect3, _rect4, _rect5, _g, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path10, _path11, _path12, _path13, _rect12, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect13, _g2, _g3, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect14, _circle, _path50, _path51, _rect15, _circle2, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 305.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{fill:#c1cbe3;}.cls-4{fill:#f5f7fc;}.cls-5{fill:#7abdf4;}.cls-6{fill:#4795e2;}.cls-11,.cls-7{fill:#d8e1f6;}.cls-8{fill:#b2bed5;}.cls-11,.cls-9{opacity:0.33;}.cls-10{opacity:0.73;}.cls-12{fill:#189db2;}.cls-13{fill:#253154;}.cls-14{fill:#19579f;}.cls-15{fill:#daa9a0;}.cls-16{fill:#e1b8b1;}.cls-17{clip-path:url(#clip-path);}.cls-18{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.93,
    y: 89.78,
    width: 29.49,
    height: 22.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 212.79,
    y: 91.56,
    width: 25.79,
    height: 18.87
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.51,69.33a10.79,10.79,0,0,0-20-5.45,6.16,6.16,0,0,0-7.41,3.81,6.56,6.56,0,0,0-1.18-.11,6.94,6.94,0,0,0-.76,13.83v0h27.68a6.17,6.17,0,0,0,1.63-12.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.64,45.79c-26.49,0-47.19,26-50.14,53.91-3,28.74,12.74,59.58,27.2,83.51s27.69,40.91,44.63,47.47c7.13,2.76,14.92,3.67,22.76,3.67,10.71,0,21.49-1.69,30.71-2.62a139.85,139.85,0,0,1,14.8-.86c9.41,0,18.49,1.21,30.81,4,12.7,2.93,28.84,7.55,40.41,7.55,5.27,0,9.59-1,12.2-3.47,8.4-8.1-.62-32.14,8.22-57s35.48-50.44,32.45-64.84c-2.95-13.94-34-17.19-58.26-17.19h-2.07c-8.63.07-16.25.53-23.58.53-13.53,0-26.08-1.57-42.19-10.11-24.85-13.16-58.16-43-85.67-44.5-.77,0-1.53-.07-2.28-.07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.91,231.52c-1.91-4.16-1.53-5.75-.88-6.45,2.21-2.37,9.3,3.75,14.21.88,3.4-2,1.55-5.8,5.72-9.08,3.62-2.86,6.87-1.43,9.38-4.54,1.54-1.92,1.64-4.12,1.76-6.45.27-5.69-1.66-14.76-6.89-16.12-2.19-.57-4.17.41-7.77,2.19-4.95,2.46-4.86,4.23-9.23,6.16s-6.66,1.06-7.62,2.93c-1.29,2.5,2.18,5,.88,8.35-.93,2.39-3.65,3.48-4.84,4-4.13,1.67-6.41-.26-7.91,1.32-2.06,2.16.32,7.74,1.46,10.4a28.85,28.85,0,0,0,3.08,5.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306,229c.44-.39,2.57-2.37,2.25-4.75-.38-2.84-4-4.37-6.28-4.77-3.66-.65-5,1.43-7.17.45-3-1.32-4.74-6.94-2.91-10.2s5.71-2,7.92-5.65a9.68,9.68,0,0,0,.95-6.26c-.72-4.84-4.36-6.29-3.84-8.94.45-2.26,3.38-3.75,5.54-4.14,4.37-.81,6.43,2.79,9.26,1.73,3.63-1.36,2.47-8.07,5.3-8.83s8,4.53,7.69,9.36c-.23,3.52-3.21,3.61-4.6,8.33-1.3,4.36.68,6.21-.39,11.21-.61,2.81-2.38,3.39-3.38,7.19-.79,3-.44,4.46-.32,4.88.55,2.06,1.74,2.46,2.58,4.49a9.46,9.46,0,0,1,.32,5.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.94,232.34c1-4.51.22-7.4-.73-9.23-1.81-3.48-4.59-3.86-6.6-7.76a14.51,14.51,0,0,1-1.46-7.78c1-7.85,9.92-8.6,10.51-14.91.56-6-7.1-8.67-5.86-14.65.72-3.51,4.1-6,6.63-7.08,5.65-2.33,8.76,1.94,13.73-.15s3.86-7.47,8.95-9.77c4.62-2.1,11.49-.62,14.65,3.51,4.34,5.68.35,15.31-3.22,20.23-3.78,5.21-7,4.94-7.62,8.5-1.1,5.79,8.27,8.83,8.2,17.29a10,10,0,0,1-1.43,5.6c-3.14,4.85-9.32,3.26-14.2,7.84a15.18,15.18,0,0,0-4.3,8.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.7,233.73h0a.57.57,0,0,1-.55-.61c.95-20.37,6.41-40.5,15.37-56.7a.58.58,0,1,1,1,.56c-8.87,16.05-14.28,36-15.22,56.19A.59.59,0,0,1,324.7,233.73Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 305.33,
    y: 225.97,
    width: 38.74,
    height: 14.35
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "338.7 277.41 310.7 277.41 307.11 240.32 342.3 240.32 338.7 277.41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.17,49.34A18.49,18.49,0,0,0,123,40a10.53,10.53,0,0,0-12.69,6.52,12.36,12.36,0,0,0-2-.18A11.89,11.89,0,0,0,107,70v.07h47.43a10.57,10.57,0,0,0,2.79-20.77Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M205,188.61H170.5l6.22-2a3.82,3.82,0,0,0,2.64-3.63V164.74h16.8V183a3.82,3.82,0,0,0,2.64,3.63Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 170.5,
    y: 187.34,
    width: 34.52,
    height: 1.27
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.77,185.41c-6.31,0-7.11,3.2-7.11,3.2h13S229.08,185.41,222.77,185.41Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 134.57,
    y: 187.34,
    width: 34.52,
    height: 1.27,
    rx: 0.33
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.31,
    y: 124.84,
    width: 80.9,
    height: 53.05,
    rx: 2.97
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 150.42,
    y: 127.93,
    width: 74.68,
    height: 42.44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 152.67,
    y: 133.86,
    width: 14.44,
    height: 14.79
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 169.82,
    y: 146.9,
    width: 14.44,
    height: 16.96
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 186.98,
    y: 133.86,
    width: 18.84,
    height: 20.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 208.53,
    y: 133.86,
    width: 14.99,
    height: 16.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 208.53,
    y: 152.09,
    width: 14.99,
    height: 16.13
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.67,
    y: 150.7,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.67,
    y: 154.03,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.67,
    y: 157.37,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.67,
    y: 160.7,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.67,
    y: 164.04,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 169.82,
    y: 133.44,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 169.82,
    y: 136.78,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 169.82,
    y: 140.12,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 169.82,
    y: 143.45,
    width: 14.44,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 186.98,
    y: 156.71,
    width: 18.84,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 186.98,
    y: 160.04,
    width: 18.84,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 186.98,
    y: 163.38,
    width: 18.84,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 186.98,
    y: 166.71,
    width: 18.84,
    height: 0.96
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 152.67,
    y: 129.07,
    width: 9.73,
    height: 2.28
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 165.56,
    y: 130.54,
    width: 4.94,
    height: 0.82
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 172.1,
    y: 130.54,
    width: 4.94,
    height: 0.82
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 178.64,
    y: 130.54,
    width: 4.94,
    height: 0.82
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 185.19,
    y: 130.54,
    width: 4.94,
    height: 0.82
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 191.73,
    y: 130.54,
    width: 4.94,
    height: 0.82
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M69.2,277.52a1.29,1.29,0,0,1-1.29-1.29V194.46a1.29,1.29,0,1,1,2.58,0v81.77A1.29,1.29,0,0,1,69.2,277.52Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M300.82,277.52a1.29,1.29,0,0,1-1.29-1.29V194.46a1.29,1.29,0,0,1,2.58,0v81.77A1.29,1.29,0,0,1,300.82,277.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.15,277.77a1.54,1.54,0,0,1-1.55-1.54V194.46a1.55,1.55,0,0,1,3.09,0v81.77A1.54,1.54,0,0,1,49.15,277.77Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320.88,277.77a1.54,1.54,0,0,1-1.55-1.54V194.46a1.55,1.55,0,0,1,3.1,0v81.77A1.55,1.55,0,0,1,320.88,277.77Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.06,
    y: 188.61,
    width: 315.71,
    height: 5.85
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.77,188.64a.76.76,0,0,1-.77-.77V167.4a21.83,21.83,0,0,1,3.75-12.28l14.61-21.64a.77.77,0,1,1,1.28.87L60,156a20.38,20.38,0,0,0-3.49,11.42v20.47A.76.76,0,0,1,55.77,188.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.47,136.87l-4.4,7.88a4.51,4.51,0,1,0,4.4-7.88Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75,137.62l-4.32-2.41a.85.85,0,0,1-.41-.74,4.42,4.42,0,0,1,2.21-4,.82.82,0,0,1,.83,0l4.32,2.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74,133.94c-2.43,4.35-.49,10.06,7.88,14.74a41.45,41.45,0,0,0,8.8-15.74C82.47,128.35,76.42,129.59,74,133.94Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.13,187.13a51.38,51.38,0,0,0-28.72,0v1.48H70.13Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M128.83,277.22h-.06a1,1,0,0,1-.93-1.05l2.31-40.27a1,1,0,1,1,2,.11l-2.31,40.27A1,1,0,0,1,128.83,277.22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.36,277.4a1.07,1.07,0,0,1-.39-.07,1.17,1.17,0,0,1-.71-1.5l15.51-43.47a1.17,1.17,0,0,1,2.21.78L86.47,276.62A1.19,1.19,0,0,1,85.36,277.4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M149.21,277.22a1,1,0,0,1-1-.85l-5.92-40.88a1,1,0,0,1,.85-1.13,1,1,0,0,1,1.12.84l5.91,40.88a1,1,0,0,1-.84,1.13Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.61,277.4a1.07,1.07,0,0,1-.25,0,1.17,1.17,0,0,1-.89-1.4l9.4-42.65a1.17,1.17,0,0,1,2.29.5l-9.41,42.66A1.16,1.16,0,0,1,105.61,277.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.11,185.18h26.61a5.2,5.2,0,0,1,5.14,4.41l4.08,26.6a8.27,8.27,0,0,0,8.17,7h22.35a3.07,3.07,0,0,1,3.08,3.07v2.78a5.21,5.21,0,0,1-3.38,4.87c-8.83,3.31-40.07,12.09-57.83.7s-15.1-35-13.34-45.13A5.19,5.19,0,0,1,88.11,185.18Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M132.49,151c5.62,6,16.2,14.76,17.28,14.89S164,151.58,164,151.58l5.59,4.82s-12.73,24.68-20.21,24.77-19.52-7.55-23.39-15.08S125.17,143.17,132.49,151Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M171.18,260.74c0,5.26.19,8.26,3.57,9s7.32.94,9.1,2.63a4.34,4.34,0,0,1,1.32,3.85h-22a34.32,34.32,0,0,1,1.5-8.07,29.53,29.53,0,0,0,.66-7.23Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M125.82,208.64c17.8-3.61,49.53-8.51,54.31-2.58s-6.71,57.79-6.71,57.79h-9.16l4.11-45.92Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M204,259.06c3.16,4.2,5.12,6.48,8.27,5.05s6.41-3.65,8.85-3.38A4.34,4.34,0,0,1,224.5,263L207,276.23a34.88,34.88,0,0,1-3.65-7.35,29.5,29.5,0,0,0-3.83-6.17Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M126,124.84a5.85,5.85,0,0,0,2.45-8.47c-1.72-2.75-6.58-1.12-10.32,2.36s-8.69,5.12-9.72,9.51,2.24,9.2,5.2,12.16S126,124.84,126,124.84Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M97.83,204.64c-.39,9.81,1.29,18.32,14.44,20.39s44.38,5.41,44.38,5.41l44.18,35.9,7.68-5.6s-34.7-39.58-38.83-43.33-37.28-8.64-43.86-8.77l-.52-7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.51,144.58c9-.63,14.3,4,16,6.43s1.33,12.1.17,22.93a141.57,141.57,0,0,0-.12,24.9c.26,3.74-2.72,5.93-4.92,6.58s-22.4,1.18-27.56.8-4.43-3.77-3.91-9.57a155.46,155.46,0,0,0-.15-21.8c-.48-7.91-6.71-20.56-1.4-23.61A52.15,52.15,0,0,1,116.51,144.58Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M124.4,140.73a20.09,20.09,0,0,0-.52,8.19c-1.18,7-13.13,4.73-14.19.34,1.12-5.76,4.53-11,6.28-12.38C119.5,134,125.61,136.19,124.4,140.73Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M126,124.84s3.67,9.57,4.82,12.44c.93,2.34-7.93,6.38-12.76.78-.6.91-1.86.67-2.66-.11s-1.28-2.74.53-3.23c0,0-1.6-2.76-1.29-4.28S126,124.84,126,124.84Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M109.71,195.39c-2.63.73-2.78,2.8-2.63,4.3.24,2.25-1.39,2.83-1.59,1.5-.22-1.53.05-3.74-.6-4.51a10,10,0,0,1-1.2-2.37l.56-2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M105.29,188.68c2.44.73,7.27,4.76,8,6.65a13.52,13.52,0,0,1-.23,8.1c-.43,1-3,1.51-3.53,1.76-.91.43-1.17-1,.22-1.82.37-.21,1.34-.3,1.53-1,.53-1.85-.51-4.56-.83-5.12-1.74-2.95-4.92-1.44-6.42-4l1.3-4.57"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M94.6,151.24c-14.06,11-22.9,24.75-22.13,32.36s30.7,12.51,30.7,12.51l2.32-8.12-16-7.49s4.72-5.06,9.23-9.14C103.54,167,102.77,144.83,94.6,151.24Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M164.52,152.06c-1.55-5-1.15-7.64-1.81-9.73-.32-1,1.87-1.55,2.52,1.29s2.06,3.28,2.06,3.28h14.77c1.74,0,1.74,2,1.1,2s-8.21.74-9.72,1.3c-1,.39-5.64,4.68-5.64,4.68Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M242.36,106.53s-9.6.14-10.14,2.36,4,9.68,5.79,10,4,.71,4.77-1.81a6,6,0,0,0,3.68.44l2.8-4.64Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.93,
    y: 89.78,
    width: 29.49,
    height: 22.34
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.93,
    y: 89.78,
    width: 29.49,
    height: 22.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.17,94.54a3.52,3.52,0,1,1-3.51-3.64A3.57,3.57,0,0,1,233.17,94.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "248.21 112.12 220.15 112.12 234.18 97.59 248.21 112.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "234.18 112.12 201.52 112.12 217.85 95.22 234.18 112.12"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 212.79,
    y: 91.56,
    width: 25.79,
    height: 18.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M229.9,96.1a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,229.9,96.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "245.38 110.42 220.84 110.42 233.11 98.15 245.38 110.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "233.11 110.42 204.56 110.42 218.84 96.15 233.11 110.42"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M250.64,110.57s-4.35-4.39-5.47-5.25-8.17-.86-10-.86-1.8,2.75,1.46,2.75c2.67,0,5.36.3,5.36.3a7.42,7.42,0,0,0,5.43,8.37C251.62,117,250.64,110.57,250.64,110.57Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M287.9,69.67c-3.5-1.36-6.77-7-2.37-10.61s11.62-4.4,16.13-3.38,6.46,8.44,5.54,18.26S287.9,69.67,287.9,69.67Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M267.21,254.62c3.27,4.11,5,6.58,2.81,9.27s-5.14,5.29-5.49,7.72a4.36,4.36,0,0,0,1.37,3.83l17.19-13.66a34.55,34.55,0,0,0-6.2-5.39,29.45,29.45,0,0,1-5-5.24Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M289.63,87.17c-6.5,5.75-10.1,15.35-13.24,22.19a94.85,94.85,0,0,1-5.85,11l-19.26-10.84-5,8.26s21.13,19.29,26.31,18.74,13.93-10.14,18.06-22S294.1,83.21,289.63,87.17Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M298,151.29c-4.55,20.7-19.21,24.5-40.12,47.62,8.77,21.85,19.91,55.63,19.91,55.63L268.2,261s-28.92-50.27-29.95-62.66,33.34-34.2,35.62-38.59,5.61-15.1,5.61-15.1Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M308.72,83c13.63,2.22,18.23,9.29,19.95,15s-2.06,19.09-9.46,31.13c-5.81,9.47-.86,20.47-9.63,24.42a102,102,0,0,1-30.1-8.94c-5.16-12.39,2.75-13.93,2.93-30.45s1.72-22.87,7.22-27S301.33,81.84,308.72,83Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M296.57,77c.5,4.92,1.08,7.59.89,10,1.67,7.14,16.16,3,14.17-2.41-3.34-9.06-6.27-12.33-8.22-14.92C301,68.17,296,70.89,296.57,77Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M287.9,69.67s5.12,9.53,6.71,12.1c1.75,2.82,8.8-1.84,8.57-9.62,1.12,0,2.52-1.53,2.11-3.56s-3.07-2.14-3.35,0c-1.78-3.07-2.73-5-4.7-4.11S287.9,69.67,287.9,69.67Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M328.67,98c6.39,24.65,6.16,61.14,3.27,85.21H323c1.37-40.59-12.92-60.27-10.49-73.86S325.75,86.71,328.67,98Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M323.75,183.22c-1.55,5-1.35,7.87-2,10-.32,1,1.87,1.54,2.52-1.29s2.06-3.28,2.06-3.28H341.1c1.74,0,1.74-2,1.1-2s-7.79-.22-9.29-.78a27.21,27.21,0,0,1-3.87-2.6Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M243,258.88c-2,4.87-3.27,7.59-6.69,7s-7.14-1.88-9.42-1a4.34,4.34,0,0,0-2.66,3.08l20.36,8.23a34.29,34.29,0,0,0,1.63-8.05,29.36,29.36,0,0,1,2.1-6.94Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M279.48,144.62c2.53,7.14,5.23,12.51,3.56,17.58-29.25,42.93-36.42,70.55-45.4,100.28l10.5,3.16s30.93-69.46,51.67-89.54c7.84-7.59,9-11,9.77-22.54C305.81,145.14,279.48,144.62,279.48,144.62Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 143.69,
    y: 115.54,
    width: 59.52,
    height: 18.6,
    rx: 3.17
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 153.64,
    cy: 124.84,
    r: 6.31
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.58,122.36a1.19,1.19,0,0,0,1.19,1.19h30.65a1.19,1.19,0,1,0,0-2.38H165.77a1.19,1.19,0,0,0-1.19,1.19Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.58,127.47a1.19,1.19,0,0,0,1.19,1.19h30.65a1.19,1.19,0,1,0,0-2.38H165.77a1.19,1.19,0,0,0-1.19,1.19Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 143.36,
    y: 91.91,
    width: 59.52,
    height: 18.6,
    rx: 3.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 153.64,
    cy: 101.21,
    r: 6.31
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.58,98.73a1.19,1.19,0,0,0,1.19,1.19h30.65a1.19,1.19,0,1,0,0-2.38H165.77a1.19,1.19,0,0,0-1.19,1.19Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.58,103.84a1.19,1.19,0,0,0,1.19,1.19h30.65a1.19,1.19,0,1,0,0-2.38H165.77a1.19,1.19,0,0,0-1.19,1.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/ABOUT_US.515cb60314f0999af67096802e6ab466.svg";
export { ForwardRef as ReactComponent };